/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  SettleRealizedPnlRecordsOptions,
  SettleRealizedPnlRecordsResponses,
} from '../types/SettleRealizedPnlRecords'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Mark multiple realized P&L settlements as settled
 * {@link /v1/realized_pnl_settlements}
 */
export function settleRealizedPnlRecords<ThrowOnError extends boolean = true>(
  options: Options<SettleRealizedPnlRecordsOptions, ThrowOnError>,
): Unwrappable<RequestResult<SettleRealizedPnlRecordsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'PUT',
      url: '/v1/realized_pnl_settlements',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<SettleRealizedPnlRecordsResponses, ThrowOnError>>,
  )
}
